// extracted by mini-css-extract-plugin
module.exports = {"label":"text-area_label__4EskI","textArea":"text-area_textArea__pXicU","textAreaWithoutLabel":"text-area_textAreaWithoutLabel__aP0ji"};